import { render, staticRenderFns } from "./MatchPotential.vue?vue&type=template&id=4385c02a&scoped=true&"
import script from "./MatchPotential.vue?vue&type=script&lang=js&"
export * from "./MatchPotential.vue?vue&type=script&lang=js&"
import style0 from "./MatchPotential.vue?vue&type=style&index=0&id=4385c02a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4385c02a",
  null
  
)

export default component.exports